<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pt-8 pb-12" :class="{ 'opacity-0 pointer-events-none': route.name === 'start' }">
    <div class="grid gap-6 leading-6">
      <div class="text-coral flex items-end mb-1">
        <AtomIcon name="bb-logo-name" class="text-[1.5rem]" />
      </div>
      <div class="text-sm" v-html="$t('shared.footer.tagline')" />
      <div class="navigation text-sm" v-if="footerNav.length">
        <NuxtLink :to="item.url ? item.url : { path: item.path, query: item.query }" v-for="item in footerNav" :key="item.id">
          <div v-html="item.title" />
        </NuxtLink>
      </div>
      <div class="navigation text-sm" v-if="cities?.length">
        <NuxtLink :to="`/${city.slug}`" v-for="city in cities" :key="city.id">
          <div v-html="city.name" />
        </NuxtLink>
      </div>
      <hr>
      <div class="text-sm">Copyright {{ $dayjs().format('YYYY') }} - {{ [$t('shared.footer.company'), $t('shared.footer.address')].join(', ') }}</div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const app = useAppStore()
const cities = computed(() => app.cities?.filter(city => city?.sections))
const footerNav = computed(() => app.config?.navigation?.footer)
</script>

<style lang="scss" scoped>
.navigation {
  @apply flex flex-wrap items-center gap-4 gap-y-2 max-w-4xl;
}
</style>

